var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leasingVehicleCard" }, [
      _c("div", {
        staticClass:
          "leasingVehicleCard__image leasingVehicleCard__image--loading",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "leasingVehicleCard__body" }, [
        _c("div", {
          staticClass:
            "leasingVehicleCard__title leasingVehicleCard__title--loading",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "leasingVehicleCard__subtitle leasingVehicleCard__subtitle--loading",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "leasingVehicleCard__price leasingVehicleCard__price--loading",
        }),
        _vm._v(" "),
        _c("ul", { staticClass: "leasingVehicleCard__contractList" }, [
          _c("li", {
            staticClass: "leasingVehicleCard__contractList__loading",
          }),
          _vm._v(" "),
          _c("li", {
            staticClass: "leasingVehicleCard__contractList__loading",
          }),
          _vm._v(" "),
          _c("li", {
            staticClass: "leasingVehicleCard__contractList__loading",
          }),
          _vm._v(" "),
          _c("li", {
            staticClass: "leasingVehicleCard__contractList__loading",
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "leasingVehicleCard__buttonGroup" }, [
          _c("div", { staticClass: "leasingVehicleCard__buttonLoading" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }